import React from "react";
import { Box, Typography, Grid, Card, CardContent, Chip } from "@mui/material";
import { motion } from "framer-motion";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import BoltIcon from "@mui/icons-material/Bolt";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import SendIcon from "@mui/icons-material/Send";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import SecurityIcon from "@mui/icons-material/Security";

const SERVICES = [
  {
    icon: <BoltIcon sx={{ fontSize: 28 }} />,
    label: "BBPS Bill Payments",
    desc: "Electricity, water, gas, DTH, broadband and 100+ more utility bills paid instantly.",
    color: "#16a34a", bg: "#f0fdf4", border: "#bbf7d0",
    tag: "500+ Billers",
  },
  {
    icon: <AccountBalanceWalletIcon sx={{ fontSize: 28 }} />,
    label: "Digital Wallet",
    desc: "Load money, check balance, and manage your full KYC wallet seamlessly.",
    color: "#0ea5e9", bg: "#f0f9ff", border: "#bae6fd",
    tag: "Instant",
  },
  {
    icon: <SendIcon sx={{ fontSize: 28 }} />,
    label: "Money Transfer",
    desc: "Send to bank accounts or other wallets in seconds with IMPS and UPI.",
    color: "#7c3aed", bg: "#faf5ff", border: "#ddd6fe",
    tag: "Zero Fees",
  },
  {
    icon: <CreditCardIcon sx={{ fontSize: 28 }} />,
    label: "RuPay Card",
    desc: "Get your virtual or physical RuPay prepaid card for seamless POS and online payments.",
    color: "#dc2626", bg: "#fff1f2", border: "#fecdd3",
    tag: "Contactless",
  },
  {
    icon: <CardGiftcardIcon sx={{ fontSize: 28 }} />,
    label: "Gift Cards",
    desc: "Send digital gift vouchers for any occasion — birthdays, festivals, milestones.",
    color: "#d97706", bg: "#fffbeb", border: "#fde68a",
    tag: "100+ Brands",
  },
  {
    icon: <SecurityIcon sx={{ fontSize: 28 }} />,
    label: "Secured Payments",
    desc: "Bank-grade 256-bit encryption with TPIN, OTP, and AI-powered fraud detection.",
    color: "#0891b2", bg: "#ecfeff", border: "#a5f3fc",
    tag: "ISO Certified",
  },
];

export default function ServicesSection() {
  return (
    <Box id="services" sx={{ py: { xs: 8, md: 12 }, px: { xs: 3, md: 8, lg: 12 }, bgcolor: "#fafafa" }}>
      {/* Heading */}
      <Box sx={{ textAlign: "center", mb: { xs: 6, md: 8 }, maxWidth: 640, mx: "auto" }}>
        <Chip label="What We Offer" sx={{ bgcolor: "#dcfce7", color: "#15803d", fontWeight: 700, fontSize: 12, mb: 2, px: 1 }} />
        <Typography sx={{ fontSize: { xs: 28, md: 40 }, fontWeight: 900, color: "#0f172a", letterSpacing: "-1px", lineHeight: 1.15, mb: 1.5 }}>
          Everything you need,<br />in one place
        </Typography>
        <Typography sx={{ fontSize: { xs: 15, md: 17 }, color: "#64748b", lineHeight: 1.75 }}>
          From paying bills to sending money — TA Wallet handles it all securely and instantly.
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {SERVICES.map((s, i) => (
          <Grid size={{xs:12, md:4, sm:6}} item xs={12} sm={6} md={4} key={i}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
            >
              <Card sx={{
                borderRadius: "20px", height: "100%",
                border: `1.5px solid ${s.border}`,
                bgcolor: "white",
                boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
                transition: "all 0.25s ease",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: `0 16px 40px ${s.color}22`,
                  borderColor: s.color,
                },
              }}>
                <CardContent sx={{ p: 3 }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
                    <Box sx={{
                      width: 56, height: 56, borderRadius: "16px",
                      bgcolor: s.bg, display: "flex", alignItems: "center",
                      justifyContent: "center", color: s.color,
                      border: `1.5px solid ${s.border}`,
                    }}>
                      {s.icon}
                    </Box>
                    <Chip label={s.tag} size="small"
                      sx={{ bgcolor: s.bg, color: s.color, fontWeight: 700, fontSize: 10, border: `1px solid ${s.border}` }} />
                  </Box>
                  <Typography sx={{ fontSize: 17, fontWeight: 800, color: "#0f172a", mb: 1, lineHeight: 1.3 }}>
                    {s.label}
                  </Typography>
                  <Typography sx={{ fontSize: 14, color: "#64748b", lineHeight: 1.7 }}>
                    {s.desc}
                  </Typography>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
